export const PHONE_NUMBER_REGEX = /(^[0-9]{4}$)|(^[0][0-9]{8,9}$)|^(?![\s\S])/;
export const POSTCODE_REGEX = /^[0-9]{5}$|^(?![\s\S])/;
